import React from 'react';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { Grid, Typography } from '@material-ui/core';

const Pagination = ({ page, totalPages, onChange }) => {
  const tp = Math.max(1, totalPages || 1);

  const handleBack = () => {
    if (page > 1) onChange(page - 1);
  };

  const handleNext = () => {
    if (page < tp) onChange(page + 1);
  };

  return (
    <Grid container alignItems='center' justify='center' style={{ paddingTop: '1rem' }}>
      <ArrowBackIosIcon
        size='small'
        titleAccess='Previous'
        onClick={handleBack}
        color={page === 1 ? 'disabled' : 'action'}
        style={{ cursor: 'pointer' }}
      />
      <Typography variant='body1' style={{ padding: '0 0.5rem 0 0.5rem' }}>
        {page} out of {tp} pages
      </Typography>
      <ArrowForwardIosIcon
        size='small'
        titleAccess='Next'
        onClick={handleNext}
        color={page >= tp ? 'disabled' : 'action'}
        style={{ cursor: 'pointer' }}
      />
    </Grid>
  );
};

export default Pagination;
